<template>
    <div style="background-color: white;box-sizing:unset;min-width:1600px">
        <headers></headers>
        <!-- 中间内容区域开始 -->
         <!-- 中文版 -->
        <div v-if="langluageType != 'en'" class="window_con">
            <div class="window_banner">
                <img src="../assets/propaganda/articlehub.jpg" class="window_banner_img">
                <div class="banner_text">
                    <img src="../assets/propaganda/hub_logo.svg" class="banner_text_img">
                    <h1>面向场馆运营企业</h1>
                    <p>场馆各项业务全流程一体化实时在线云管理系统</p>
                    <ul class="banner_ul">
                        <li data-type="Hub场馆云" data-href="/web/user/login" id="ljsy"><a href="javascript:;">立&nbsp;即&nbsp;试&nbsp;用</a></li>
                    </ul>
                </div>
            </div>
            <div class="article">
                <div class="tit_con">
                    <h1>场馆云的解决方案</h1>
                    <p>解决传统模式中，销售痕迹保存难、客户跟踪效果差、时段信息更新慢、资料核实流程长、现场执行管理难、综合运营成本高等问题</p>
                </div>
                <div class="article_con clearfix">
                    <div class="article_con_module">
                        <h2>提高业务敏捷性</h2>
                        <ul>
                            <li><i class="square"></i>行业特定的功能和卓越实践</li>
                            <li><i class="square"></i>基于国内大型展馆运营流程</li>
                            <li><i class="square"></i>实时嵌入式BI统计分析</li>
                            <li><i class="square"></i>覆盖展馆运营全过程的自动化流程</li>
                        </ul>
                    </div>
                    <div class="article_con_module">
                        <h2>获得稳定性和控制力</h2>
                        <ul>
                            <li><i class="square"></i>腾讯云部署确保数据安全</li>
                            <li><i class="square"></i>集成的商业智能快速把握新机遇</li>
                            <li><i class="square"></i>项目创建、客户管理、简化流程</li>
                            <li><i class="square"></i>注册即用，部署速度快</li>
                        </ul>
                    </div>
                    <div class="article_con_module">
                        <h2>持续降本可持续性</h2>
                        <ul>
                            <li><i class="square"></i>在线销售、合同编辑、信息同步灵活</li>
                            <li><i class="square"></i>在线时段、现场监督、物流管控敏捷性高</li>
                            <li><i class="square"></i>内部沟通、任务派遣、押金管理一气呵成</li>
                            <li><i class="square"></i>支持实时分析，帮助提高利润和效率</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- 英文版 -->
        <div v-else class="window_con">
            <div class="window_banner">
                <img src="../assets/propaganda/articlehub1.jpg" class="window_banner_img">
                <div class="banner_text">
                    <img src="../assets/propaganda/hub_logo.svg" class="banner_text_img">
                    <h1>Online cloud system for venue operator</h1>
                    <!-- <p style="line-height: normal;margin-top: 18px;margin-bottom: 18px;font-weight: 400;">A real-time online cloud management system that integrates all<br/> business processes of the venue</p>
                    <ul class="banner_ul">
                        <li data-type="Hub场馆云" data-href="/web/user/login" id="ljsy"><a href="javascript:;">Try it now</a></li>
                    </ul> -->
                </div>
            </div>
            <div class="article" style="width: 1600px;margin-top:70px;margin-bottom: 140px;">
                <!-- <div class="tit_con">
                    <h1>Hub cloud solutions</h1>
                    <p>Solve the problems in the traditional model, such as difficulty in preserving sales traces, poor customer tracking effect, slow time period information update, long data verification process, difficult on-site execution management, and high comprehensive operating costs.</p>
                </div> -->
                <div class="article_con clearfix">
                    <div class="article_con_module" style="width:30%">
                        <h2>Improve business agility</h2>
                        <ul>
                            <li><i class="square"></i>Industry-specific capabilities and best practices</li>
                            <li><i class="square"></i>Based on the operation process of large domestic exhibition halls</li>
                            <li><i class="square"></i>Real-time embedded BI statistical analysis</li>
                            <li><i class="square"></i>Automated process covering the entire exhibition hall operation <br/><span style="margin-left: 18px;">process</span></li>
                        </ul>
                    </div>
                    <div class="article_con_module" style="width:34%">
                        <h2>Gain stability and control</h2>
                        <ul>
                            <li><i class="square"></i>Tencent Cloud deployment ensures data security</li>
                            <li><i class="square"></i>Integrated business intelligence to quickly seize new opportunities</li>
                            <li><i class="square"></i>Project creation, client management, streamlined processes</li>
                            <li><i class="square"></i>Register and use, fast deployment</li>
                        </ul>
                    </div>
                    <div class="article_con_module" style="width:36%">
                        <h2>Continuous cost reduction and sustainability</h2>
                        <ul>
                            <li><i class="square"></i>Online sales, contract editing, flexible information synchronization</li>
                            <li><i class="square"></i>High agility in online hours, on-site supervision, and logistics control</li>
                            <li><i class="square"></i>Internal communication, task dispatch, and deposit management are all done<br/><span style="margin-left: 18px;">in one go</span></li>
                            <li><i class="square"></i>Supports real-time analysis to help improve profits and efficiency</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- 中间内容区域结束 -->
        <footers></footers>
        <contact></contact>
        <dialog1 data-type="Hub场馆云"></dialog1>
    </div>
</template>
<script>
  import headers from '@/components/Header';
  import footers from '@/components/Footer';
  import contact from '@/components/contact';
  import dialog1 from '@/components/dialog';

export default {
    components: {
      headers,
      footers,
      contact,
      dialog1
    },
    data(){
        return {
            langluageType:sessionStorage.getItem('langluageType')||'ch'
        }
    },
}
</script>


// WEBPACK FOOTER //
// src/page/articlehub.vue